import client from './client';
import { Project, ProjectListResponse } from '../types';

export const getProjects = async (
  page: number = 1,
  category?: string
): Promise<ProjectListResponse> => {
  const params: Record<string, any> = { page };
  if (category && category !== 'All') {
    params.category = category;
  }
  const response = await client.get<ProjectListResponse>('/projects', { params });
  return response.data;
};

export const getProject = async (id: number): Promise<Project> => {
  const response = await client.get<Project>(`/projects/${id}`);
  return response.data;
};
